import * as BizObjectives from './BizObjectives';
import Features from './Features';
const BizObjectivesMap = {
  [BizObjectives.PERSONALIZE_EXPERIENCES]: {
    features: [Features.CALLS_TO_ACTION, Features.DYNAMIC_PERSONALIZATION],
    illustration: 'open-door'
  },
  [BizObjectives.CAPTURE_CONVERT_LEADS_CMS]: {
    features: [Features.LIVE_CHAT, Features.CONVERSATIONAL_BOTS, Features.FORMS],
    illustration: 'contacts-chat'
  },
  [BizObjectives.ATTRACT_AUDIENCE_ATTENTION]: {
    features: [Features.LANDING_PAGES, Features.AD_MANAGEMENT, Features.LIVE_CHAT, Features.CONVERSATIONAL_BOTS, Features.FORMS],
    illustration: 'forms-success'
  },
  [BizObjectives.UNDERSTAND_LEADS]: {
    features: [Features.CONTACT_WEBSITE_ACTIVITY, Features.LIST_SEGMENTATION, Features.EMAIL_HEALTH_INSIGHTS],
    illustration: 'leads'
  },
  [BizObjectives.AUTOMATE_MARKETING]: {
    features: [Features.OMNI_CHANNEL_MARKETING_AUTOMATION, Features.MULTI_LANGUAGE_CONTENT, Features.DYNAMIC_PERSONALIZATION, Features.LEAD_AND_COMPANY_SCORING],
    illustration: 'marketing-basic'
  },
  [BizObjectives.GET_FOUND_ONLINE_MARKETING]: {
    features: [Features.BLOG, Features.SEO_RECOMMEND_OPTIMIZE, Features.SOCIAL_MEDIA],
    illustration: 'call-to-action'
  },
  [BizObjectives.OPTIMIZE_CONVERSION]: {
    features: [Features.ABM_TOOLS_AND_AUTOMATION, Features.AB_TESTING, Features.ADS_OPTIMIZATION_EVENTS, Features.VIDEO_HOSTING_MANAGEMENT],
    illustration: 'content-strategy'
  },
  [BizObjectives.AUTOMATE_AND_PERSONALIZE_ENGAGEMENT]: {
    features: [Features.OMNI_CHANNEL_MARKETING_AUTOMATION, Features.ABM_TOOLS_AND_AUTOMATION, Features.DYNAMIC_PERSONALIZATION, Features.MULTI_LANGUAGE_CONTENT, Features.SOCIAL_MEDIA, Features.VIDEO_HOSTING_MANAGEMENT, Features.LEAD_AND_COMPANY_SCORING],
    illustration: 'workflows'
  },
  [BizObjectives.AUTOMATE_AND_PERSONALIZE_ENGAGEMENT_MON607]: {
    features: [Features.OMNI_CHANNEL_MARKETING_AUTOMATION, Features.SOCIAL_MEDIA],
    illustration: 'workflows'
  },
  [BizObjectives.ORCHESTRATE_EFFICIENT_CAMPAIGNS]: {
    features: [Features.COLLABORATION_TOOLS, Features.CAMPAIGN_MANAGEMENT, Features.TEAMS],
    illustration: 'campaigns'
  },
  [BizObjectives.ORCHESTRATE_EFFICIENT_CAMPAIGNS_MON607]: {
    features: [Features.TEAMS],
    illustration: 'campaigns'
  },
  [BizObjectives.OPTIMIZE_CAMPAIGN_CONVERSION]: {
    features: [Features.AB_TESTING, Features.ADS_OPTIMIZATION_EVENTS, Features.ATTRIBUTION_REPORTING],
    illustration: 'email-forwarding'
  },
  [BizObjectives.BUILD_CUSTOM_REPORTS]: {
    features: [Features.WEBSITE_TRAFFIC_ANALYTICS, Features.CAMPAIGN_REPORTING, Features.CUSTOM_REPORTS, Features.SALESFORCE_INTEGRATION],
    illustration: 'add-on-reporting'
  },
  [BizObjectives.BUILD_CUSTOM_REPORTS_MON607]: {
    features: [Features.CAMPAIGN_REPORTING, Features.CUSTOM_REPORTS],
    illustration: 'add-on-reporting'
  },
  [BizObjectives.MANAGE_TEAMS_AND_BRANDS]: {
    features: [Features.SINGLE_SIGN_ON, Features.PARTITIONING, Features.HIERARCHICAL_TEAMS, Features.PERMISSION_SETS, Features.FIELD_LEVEL_PERMISSIONS, Features.EMAIL_SEND_FREQUENCY_CAP],
    illustration: 'teams'
  },
  [BizObjectives.MANAGE_TEAMS_AND_BRANDS_MON607]: {
    features: [Features.HIERARCHICAL_TEAMS, Features.PARTITIONING],
    illustration: 'teams'
  },
  [BizObjectives.EXTEND_PLATFORM]: {
    features: [Features.CUSTOM_OBJECTS, Features.SALESFORCE_CUSTOM_OBJECT_SYNC, Features.ADAPTIVE_TESTING, Features.SANDBOXES],
    illustration: 'content-strategy'
  },
  [BizObjectives.EXTEND_PLATFORM_MON607]: {
    features: [Features.CUSTOM_OBJECTS, Features.CUSTOM_BEHAVIORAL_EVENTS],
    illustration: 'content-strategy'
  },
  [BizObjectives.ADVANCE_YOUR_REPORTING]: {
    features: [Features.MULTI_TOUCH_REVENUE_ATTRIBUTION, Features.BEHAVIORAL_EVENT_TRIGGERS, Features.PREDICTIVE_LEAD_SCORING],
    illustration: 'add-on-reporting'
  },
  [BizObjectives.ADVANCE_YOUR_REPORTING_MON607]: {
    features: [Features.MULTI_TOUCH_REVENUE_ATTRIBUTION],
    illustration: 'add-on-reporting'
  },
  [BizObjectives.ORGANIZE_YOUR_SALES_PROCESS]: {
    features: [Features.CONVERSATION_ROUTING, Features.TASK_QUEUES, Features.MULTI_CURRENCY, Features.STRIPE_INTEGRATION],
    illustration: 'task-queues'
  },
  [BizObjectives.ORGANIZE_YOUR_SALES_PROCESS_MON607]: {
    features: [Features.SIMPLE_AUTOMATION, Features.CONVERSATION_ROUTING, Features.TASK_QUEUES, Features.MULTI_CURRENCY],
    illustration: 'task-queues'
  },
  [BizObjectives.CONNECT_WITH_PROSPECTS]: {
    features: [Features.CALLING, Features.MEETINGS, Features.LIVE_CHAT],
    illustration: 'meetings'
  },
  [BizObjectives.TRACK_ITERATE_IMPROVE]: {
    features: [Features.GOALS, Features.REPORTING_DASHBOARDS],
    illustration: 'add-on-reporting'
  },
  [BizObjectives.PERSONALIZE_OUTREACH]: {
    features: [Features.SEQUENCES, Features.VIDEO_CREATION, Features.SMART_SEND_TIMES, Features.ABM_TOOLS_AND_AUTOMATION],
    illustration: 'target'
  },
  [BizObjectives.PERSONALIZE_OUTREACH_MON607]: {
    features: [Features.SEQUENCES, Features.ABM_TOOLS_AND_AUTOMATION],
    illustration: 'target'
  },
  [BizObjectives.COACH_AND_ENABLE]: {
    features: [Features.PLAYBOOKS, Features.CONVERSATION_INTELLIGENCE, Features.PREDICTIVE_LEAD_SCORING],
    illustration: 'dedicated-ip-board'
  },
  [BizObjectives.COACH_AND_ENABLE_MON607]: {
    features: [Features.PLAYBOOKS, Features.CONVERSATION_INTELLIGENCE, Features.PREDICTIVE_LEAD_SCORING],
    illustration: 'dedicated-ip-board'
  },
  [BizObjectives.CUSTOMIZE_TO_MATCH_YOUR_BUSINESS]: {
    features: [Features.CUSTOM_OBJECTS, Features.HIERARCHICAL_TEAMS, Features.SANDBOXES],
    illustration: 'custom-objects'
  },
  [BizObjectives.CUSTOMIZE_TO_MATCH_YOUR_BUSINESS_MON607]: {
    features: [Features.CUSTOM_OBJECTS],
    illustration: 'custom-objects'
  },
  [BizObjectives.EXTEND_ADMINISTRATIVE_CONTROLS]: {
    features: [Features.ADVANCED_PERMISSIONS, Features.PERMISSION_SETS, Features.FIELD_LEVEL_PERMISSIONS],
    illustration: 'open-door'
  },
  [BizObjectives.EXTEND_ADMINISTRATIVE_CONTROLS_MON607]: {
    features: [Features.ADVANCED_PERMISSIONS],
    illustration: 'open-door'
  },
  [BizObjectives.MANAGE_GROWING_TEAM]: {
    features: [Features.SALES_ANALYTICS, Features.TEAMS, Features.SALES_AUTOMATION, Features.RECORD_CUSTOMIZATION, Features.REQUIRED_FIELDS, Features.CUSTOM_REPORTS, Features.FORECASTING],
    illustration: 'team'
  },
  [BizObjectives.MANAGE_GROWING_TEAM_MON607]: {
    features: [Features.FORECASTING],
    illustration: 'team'
  },
  [BizObjectives.CONFIGURE_PRICE_QUOTE]: {
    features: [Features.PRODUCTS, Features.CALCULATED_PROPERTIES, Features.ESIGN],
    illustration: 'calculated-properties'
  },
  [BizObjectives.CONFIGURE_PRICE_QUOTE_MON607]: {
    features: [Features.PRODUCTS, Features.ESIGN],
    illustration: 'calculated-properties'
  },
  [BizObjectives.SCALE_YOUR_BUSINESS]: {
    features: [Features.CUSTOM_OBJECTS, Features.PERMISSION_SETS, Features.RECORD_CUSTOMIZATION, Features.SINGLE_SIGN_ON, Features.FIELD_LEVEL_PERMISSIONS],
    illustration: 'training-growth-consulting'
  },
  [BizObjectives.SUPERCHARGE_YOUR_PIPELINE]: {
    features: [Features.RECURRING_REVENUE_TRACKING, Features.CUSTOM_REPORTS, Features.REPORTING_DASHBOARDS],
    illustration: 'bolt'
  },
  [BizObjectives.TRACK_CUSTOMER_COMMS]: {
    features: [Features.MULTI_CURRENCY, Features.TASK_QUEUES],
    illustration: 'multiple-currency-revenue'
  },
  [BizObjectives.MAXIMIZE_PRODUCTIVITY]: {
    features: [Features.SNIPPETS, Features.TEMPLATES, Features.MEETINGS],
    illustration: 'templates'
  },
  [BizObjectives.DELIGHT_CUSTOMERS]: {
    features: [Features.TICKET_STATUS, Features.TICKET_ROUTING, Features.TASK_AUTOMATION, Features.MULTIPLE_TICKET_PIPELINES],
    illustration: 'successfully-submitted-question'
  },
  [BizObjectives.HELP_CUSTOMERS_HELP_THEMSELVES]: {
    features: [Features.KNOWLEDGE_BASE, Features.VIDEO_CREATION, Features.VIDEO_HOSTING_MANAGEMENT],
    illustration: 'dedicated-ip-board'
  },
  [BizObjectives.MEASURE_IMPROVE_CUSTOMER_EXPERIENCE]: {
    features: [Features.CUSTOM_REPORTS, Features.INSIGHTS_DASHBOARD, Features.FORECASTING],
    illustration: 'customer-feedback'
  },
  [BizObjectives.DELIVER_EXCEPTIONAL_SERVICE]: {
    features: [Features.CUSTOM_OBJECTS, Features.PLAYBOOKS, Features.GOALS],
    illustration: 'customer-support'
  },
  [BizObjectives.MANAGE_MULTIPLE_TEAMS]: {
    features: [Features.HIERARCHICAL_TEAMS, Features.PERMISSION_SETS, Features.SINGLE_SIGN_ON, Features.SLACK, Features.CALCULATED_PROPERTIES, Features.FIELD_LEVEL_PERMISSIONS],
    illustration: 'teams'
  },
  [BizObjectives.ORGANIZE_SUPPORT_CHANNELS]: {
    features: [Features.CONVERSATIONS_INBOX, Features.MOBILE_INBOX, Features.TEAM_EMAIL, Features.MULTIPLE_TICKET_PIPELINES, Features.SIMPLE_TICKET_AUTOMATION, Features.CONVERSATIONAL_BOTS, Features.CALLING],
    illustration: 'training-technical-support'
  },
  [BizObjectives.ORGANIZE_SUPPORT_CHANNELS_MON607]: {
    features: [Features.CONVERSATION_ROUTING, Features.SIMPLE_TICKET_AUTOMATION],
    illustration: 'training-technical-support'
  },
  [BizObjectives.STREAMLINE_CUSTOMER_COMMUNICATIONS]: {
    features: [Features.TASK_QUEUES, Features.TEMPLATES, Features.SNIPPETS, Features.SLACK],
    illustration: 'task-queues'
  },
  [BizObjectives.IMPROVE_RETENTION]: {
    features: [Features.EMAIL_TRACKING_NOTIFICATIONS, Features.REPORTING_DASHBOARDS],
    illustration: 'traffic-analytics'
  },
  [BizObjectives.SCALE_SUPPORT]: {
    features: [Features.CUSTOMER_SERVICE_AUTOMATION, Features.TICKET_ROUTING, Features.KNOWLEDGE_BASE, Features.SLAS],
    illustration: 'training-technical-support'
  },
  [BizObjectives.SCALE_SUPPORT_MON607]: {
    features: [Features.KNOWLEDGE_BASE, Features.CUSTOMER_SERVICE_AUTOMATION],
    illustration: 'training-technical-support'
  },
  [BizObjectives.CONNECT_SERVICE_TO_FRONT_OFFICE]: {
    features: [Features.CUSTOMER_FEEDBACK_SURVEYS, Features.CUSTOM_SURVEYS, Features.FORECASTING],
    illustration: 'customer-feedback'
  },
  [BizObjectives.EXPAND_CUSTOMER_RELATIONSHIPS]: {
    features: [Features.CHANNEL_SWITCHING, Features.CUSTOMER_PORTAL, Features.STANDARD_CONTACT_SCORING, Features.SERVICE_ANALYTICS],
    illustration: 'customer-feedback'
  },
  [BizObjectives.EXPAND_CUSTOMER_RELATIONSHIPS_MON607]: {
    features: [Features.CUSTOM_REPORTS],
    illustration: 'customer-feedback'
  },
  [BizObjectives.MANAGE_SCALING_TEAMS]: {
    features: [Features.PERMISSION_SETS, Features.HIERARCHICAL_TEAMS, Features.FIELD_LEVEL_PERMISSIONS, Features.SINGLE_SIGN_ON],
    illustration: 'permission-sets'
  },
  [BizObjectives.MANAGE_SCALING_TEAMS_MON607]: {
    features: [Features.SINGLE_SIGN_ON, Features.FIELD_LEVEL_PERMISSIONS],
    illustration: 'permission-sets'
  },
  [BizObjectives.CUSTOMIZE_YOUR_PROCESS]: {
    features: [Features.CUSTOM_OBJECTS, Features.CALCULATED_PROPERTIES, Features.RECORD_CUSTOMIZATION, Features.SANDBOXES],
    illustration: 'operations-custom-mappings'
  },
  [BizObjectives.CUSTOMIZE_YOUR_PROCESS_MON607]: {
    features: [Features.CUSTOM_OBJECTS],
    illustration: 'operations-custom-mappings'
  },
  [BizObjectives.OPTIMIZE_PERFORMANCE]: {
    features: [Features.CONVERSATION_INTELLIGENCE, Features.GOALS, Features.PLAYBOOKS],
    illustration: 'playbooks'
  },
  [BizObjectives.OPTIMIZE_PERFORMANCE_MON607]: {
    features: [Features.CONVERSATION_INTELLIGENCE, Features.PLAYBOOKS],
    illustration: 'playbooks'
  },
  [BizObjectives.SECURE_YOUR_WEBSITE]: {
    features: [Features.PREMIUM_HOSTING, Features.CDN, Features.SSL_CERTIFICATE, Features.WEB_APPLICATION_FIREWALL, Features.CUSTOM_DOMAIN_SECURITY_SETTINGS],
    illustration: 'add-on-ssl'
  },
  [BizObjectives.SECURE_YOUR_WEBSITE_MON607]: {
    features: [Features.PREMIUM_HOSTING],
    illustration: 'add-on-ssl'
  },
  [BizObjectives.BUILD_EFFICIENTLY]: {
    features: [Features.WEBSITE_THEMES, Features.DRAG_AND_DROP_EDITOR, Features.LOCAL_WEBSITE_DEVELOPMENT, Features.APP_AND_ASSET_MARKETPLACE],
    illustration: 'building'
  },
  [BizObjectives.BUILD_EFFICIENTLY_MON607]: {
    features: [Features.WEBSITE_THEMES, Features.DRAG_AND_DROP_EDITOR, Features.LOCAL_WEBSITE_DEVELOPMENT, Features.APP_AND_ASSET_MARKETPLACE],
    illustration: 'building'
  },
  [BizObjectives.LEVERAGE_FULL_PLATFORM]: {
    features: [Features.ALL_CRM_FEATURES, Features.LIVE_CHAT, Features.FORMS, Features.REPORTING_DASHBOARDS],
    illustration: 'add-on-website'
  },
  [BizObjectives.PERSONALIZE_CUSTOMER_EXPERIENCES]: {
    features: [Features.SMART_CONTENT_AND_REPORTING, Features.DYNAMIC_PERSONALIZATION, Features.PASSWORD_PROTECTED_PAGES],
    illustration: 'team'
  },
  [BizObjectives.PERSONALIZE_CUSTOMER_EXPERIENCES_MON607]: {
    features: [Features.DYNAMIC_PERSONALIZATION, Features.SMART_CONTENT_AND_REPORTING],
    illustration: 'team'
  },
  [BizObjectives.OPTIMIZE_YOUR_WEBSITE]: {
    features: [Features.ATTRIBUTION_REPORTING, Features.AB_TESTING, Features.CUSTOM_REPORTS],
    illustration: 'campaigns'
  },
  [BizObjectives.OPTIMIZE_YOUR_WEBSITE_MON607]: {
    features: [Features.AB_TESTING, Features.CUSTOM_REPORTS],
    illustration: 'campaigns'
  },
  [BizObjectives.EXPAND_CONTENT_STRATEGY]: {
    features: [Features.SEO_RECOMMEND_OPTIMIZE, Features.CONTENT_STRATEGY, Features.GOOGLE_SEARCH_CONSOLE_INTEGRATION, Features.CONTENT_STAGING],
    illustration: 'content-strategy'
  },
  [BizObjectives.EXPAND_CONTENT_STRATEGY_MON607]: {
    features: [Features.SEO_RECOMMEND_OPTIMIZE],
    illustration: 'content-strategy'
  },
  [BizObjectives.BUILD_POWERFUL_DIGITAL_EXPERIENCES]: {
    features: [Features.CUSTOM_OBJECTS, Features.MEMBERSHIPS, Features.WEB_APPS, Features.ADAPTIVE_TESTING],
    illustration: 'custom-objects-marketing'
  },
  [BizObjectives.BUILD_POWERFUL_DIGITAL_EXPERIENCES_MON607]: {
    features: [Features.CUSTOM_OBJECTS, Features.MEMBERSHIPS, Features.ADAPTIVE_TESTING, Features.WEB_APPS],
    illustration: 'custom-objects-marketing'
  },
  [BizObjectives.MANAGE_GROWING_TEAM_AND_BRAND]: {
    features: [Features.CONTENT_PARTITIONING, Features.HIERARCHICAL_TEAMS, Features.ACTIVITY_LOGGING, Features.SITE_PERFORMANCE_MONITORING, Features.CODE_ALERTS, Features.SINGLE_SIGN_ON],
    illustration: 'keys'
  },
  [BizObjectives.EXTEND_DIGITAL_PRESENCE]: {
    features: [Features.ADDITIONAL_ROOT_DOMAINS, Features.MULTI_DOMAIN_TRAFFIC_REPORTING],
    illustration: 'design-principle-human'
  },
  [BizObjectives.EXTEND_DIGITAL_PRESENCE_MON607]: {
    features: [Features.ADDITIONAL_ROOT_DOMAINS],
    illustration: 'design-principle-human'
  },
  [BizObjectives.BUILD_REMARKABLE_WEB_PAGES]: {
    features: [Features.DRAG_AND_DROP_EDITOR, Features.WEBSITE_THEMES, Features.MULTI_LANGUAGE_CREATION_TESTING, Features.HUB_DB_DYNAMIC_CONTENT, Features.LOCAL_WEBSITE_DEVELOPMENT],
    illustration: 'add-on-website'
  },
  [BizObjectives.GROW_TRAFFIC_CONVERT_LEADS]: {
    features: [Features.SEO_RECOMMEND_OPTIMIZE, Features.CONVERSATIONAL_BOTS, Features.DYNAMIC_PERSONALIZATION, Features.AB_TESTING, Features.CONTACT_ATTRIBUTION_REPORT_BUILDER],
    illustration: 'campaigns'
  },
  [BizObjectives.BUILD_POWERFUL_WEB_EXPERIENCES]: {
    features: [Features.CUSTOM_OBJECTS, Features.WEB_APPS, Features.REVERSE_PROXY_CONFIGURATION, Features.MEMBERSHIPS],
    illustration: 'add-on-website'
  },
  [BizObjectives.GOVERNANCE_AT_SCALE]: {
    features: [Features.PARTITIONING, Features.HIERARCHICAL_TEAMS, Features.ACTIVITY_LOGGING, Features.CUSTOM_DOMAIN_SECURITY_SETTINGS, Features.SITE_PERFORMANCE_MONITORING, Features.CODE_ALERTS, Features.SINGLE_SIGN_ON],
    illustration: 'permission-sets'
  },
  [BizObjectives.EXTEND_YOUR_BRAND]: {
    features: [Features.ADDITIONAL_BRAND_DOMAIN, Features.ADAPTIVE_TESTING, Features.MULTI_CURRENCY],
    illustration: 'beta'
  },
  [BizObjectives.CONNECT_TOOLS_AND_SYNC_CUSTOMER_DATA]: {
    features: [Features.CUSTOM_FIELD_MAPPINGS, Features.CUSTOM_PROPERTIES],
    illustration: 'operations-custom-mappings'
  },
  [BizObjectives.CONNECT_TOOLS_AND_SYNC_CUSTOMER_DATA_MON607]: {
    features: [Features.CUSTOM_FIELD_MAPPINGS],
    illustration: 'operations-custom-mappings'
  },
  [BizObjectives.ORGANIZE_YOUR_OPERATIONS_EFFORTS]: {
    features: [Features.REPORTING_DASHBOARDS, Features.LIST_SEGMENTATION, Features.MULTI_CURRENCY],
    illustration: 'operations-custom-mappings'
  },
  [BizObjectives.AUTOMATE_BUSINESS_PROCESSES]: {
    features: [Features.PROGRAMMABLE_AUTOMATION, Features.WEBHOOKS, Features.SCHEDULED_WORKFLOW_TRIGGERS, Features.CUSTOM_CODED_BOT_ACTIONS],
    illustration: 'workflows'
  },
  [BizObjectives.AUTOMATE_BUSINESS_PROCESSES_MON607]: {
    features: [Features.PROGRAMMABLE_AUTOMATION, Features.WEBHOOKS],
    illustration: 'workflows'
  },
  [BizObjectives.CLEAN_CUSTOMER_DATA]: {
    features: [Features.DATA_QUALITY_AUTOMATION, Features.DUPLICATE_MANAGEMENT],
    illustration: 'multiple-objects'
  },
  [BizObjectives.CLEAN_CUSTOMER_DATA_MON607]: {
    features: [Features.DATA_QUALITY_AUTOMATION],
    illustration: 'multiple-objects'
  },
  [BizObjectives.MONITOR_AND_CLEAN_DATA]: {
    features: [Features.DATA_QUALITY_COMMAND_CENTER, Features.DATA_QUALITY_AUTOMATION, Features.AI_POWERED_DATA_FORMATTING_RECOMMENDATIONS, Features.DATA_HEALTH_TRENDS, Features.BULK_DUPLICATE_MANAGEMENT],
    illustration: 'multiple-objects'
  },
  [BizObjectives.MANAGE_SCALING_BUSINESS]: {
    features: [Features.LIST_SEGMENTATION, Features.TEAMS, Features.REQUIRED_FIELDS, Features.RECORD_CUSTOMIZATION],
    illustration: 'teams'
  },
  [BizObjectives.OPERATIONS_BUILD_CUSTOM_REPORTS]: {
    features: [Features.CUSTOM_REPORTS, Features.CALCULATED_PROPERTIES, Features.STANDARD_CONTACT_SCORING, Features.COMPANY_SCORING],
    illustration: 'calculated-properties'
  },
  [BizObjectives.OPERATIONS_BUILD_CUSTOM_REPORTS_MON607]: {
    features: [Features.CUSTOM_REPORTS, Features.CALCULATED_PROPERTIES],
    illustration: 'calculated-properties'
  },
  [BizObjectives.CURATE_AND_MANAGE_DATA_WITH_EASE]: {
    features: [Features.DATASETS, Features.ADVANCED_DATA_CALCULATIONS],
    illustration: 'transactions'
  },
  [BizObjectives.CUSTOMIZE_AND_EXTEND_THE_PLATFORM]: {
    features: [Features.CUSTOM_OBJECTS, Features.SNOWFLAKE_DATA_SHARE, Features.ADVANCED_PERMISSIONS, Features.SANDBOXES],
    illustration: 'custom-objects'
  },
  [BizObjectives.TRANSFER_DATA_FAST_MON607]: {
    features: [Features.DATA_SYNC, Features.HISTORICAL_SYNC],
    illustration: 'transactions'
  },
  [BizObjectives.CONNECT_THIRD_PARTY_APPS_MON607]: {
    features: [Features.DEFAULT_FIELD_MAPPINGS],
    illustration: 'marketplace-solutions-directory'
  },
  [BizObjectives.TRACK_EMAIL_EFFORTS_MON607]: {
    features: [Features.EMAIL_REPLY_TRACKING, Features.EMAIL_HEALTH_REPORTING],
    illustration: 'email-confirmation'
  },
  [BizObjectives.ORGANIZE_YOUR_OPERATIONS_PROCESS_MON607]: {
    features: [Features.REPORTING_DASHBOARDS, Features.LIST_SEGMENTATION, Features.MULTI_CURRENCY],
    illustration: 'operations-custom-mappings'
  },
  [BizObjectives.GET_HELP_FAST_MON607]: {
    features: [Features.EMAIL_SUPPORT],
    illustration: 'customer-support'
  },
  [BizObjectives.REMOVE_BRANDING_MARKETING]: {
    features: [Features.FORMS, Features.EMAIL_MARKETING, Features.LANDING_PAGES, Features.LIVE_CHAT],
    illustration: 'remove-branding'
  },
  [BizObjectives.REMOVE_BRANDING_MARKETING_MON607]: {
    features: [Features.FORMS, Features.EMAIL_MARKETING, Features.LANDING_PAGES, Features.LIVE_CHAT],
    illustration: 'remove-branding'
  },
  [BizObjectives.REMOVE_BRANDING_SALES]: {
    features: [Features.LIVE_CHAT, Features.MEETINGS, Features.DOCUMENTS, Features.ONE_TO_ONE_EMAIL],
    illustration: 'remove-branding'
  },
  [BizObjectives.REMOVE_BRANDING_SERVICE]: {
    features: [Features.LIVE_CHAT, Features.MEETINGS, Features.DOCUMENTS, Features.ONE_TO_ONE_EMAIL],
    illustration: 'remove-branding'
  },
  [BizObjectives.REMOVE_BRANDING_SERVICE_MON607]: {
    features: [Features.LIVE_CHAT, Features.MEETINGS],
    illustration: 'remove-branding'
  },
  [BizObjectives.GET_HELP_FAST]: {
    features: [Features.EMAIL_SUPPORT],
    illustration: 'transactional-email-envelope'
  },
  [BizObjectives.ADVANCED_SUPPORT]: {
    features: [Features.PHONE_SUPPORT],
    illustration: 'calling'
  },
  [BizObjectives.ADVANCED_SUPPORT_MON607]: {
    features: [Features.PHONE_SUPPORT],
    illustration: 'calling'
  },
  [BizObjectives.OPERATE_WITH_EASE_SALES]: {
    features: [Features.SIMPLE_AUTOMATION, Features.GOALS],
    illustration: 'building'
  },
  [BizObjectives.OPERATE_WITH_EASE_SALES_MON607]: {
    features: [Features.CALLING_SDK],
    illustration: 'building'
  },
  [BizObjectives.OPERATE_WITH_EASE_SERVICE]: {
    features: [Features.CALLING_SDK],
    illustration: 'building'
  },
  [BizObjectives.CONVERT_AND_NURTURE_LEADS]: {
    features: [],
    illustration: 'qualify-leads'
  },
  [BizObjectives.MEASURE_REVENUE]: {
    features: [],
    illustration: 'multiple-currency-revenue'
  },
  [BizObjectives.ORGANIZE_YOUR_TEAM]: {
    features: [],
    illustration: 'team'
  },
  [BizObjectives.STREAMLINE_YOUR_OUTREACH]: {
    features: [],
    illustration: 'campaigns'
  },
  [BizObjectives.HELP_AND_DELIGHT_CUSTOMERS]: {
    features: [],
    illustration: 'sunny'
  },
  [BizObjectives.CREATE_REMARKABLE_WEBSITES]: {
    features: [],
    illustration: 'add-on-website'
  },
  [BizObjectives.CUSTOMIZE_USING_TOOLS]: {
    features: [],
    illustration: 'building'
  },
  [BizObjectives.GET_SPEED_RELIABILITY_SECURITY]: {
    features: [],
    illustration: 'account-security'
  },
  [BizObjectives.STREAMLINE_B2B_BUYING]: {
    features: [Features.PAYMENTS],
    illustration: 'payments'
  },
  [BizObjectives.GROW_YOUR_REVENUE]: {
    features: [Features.PAYMENTS],
    illustration: 'payments'
  },
  [BizObjectives.MARKETING_AUTOMATION]: {
    features: [Features.FORM_AUTOMATION, Features.EMAIL_AUTOMATION],
    illustration: 'workflows'
  }
};
export default BizObjectivesMap;